import { Box, LinearProgress, Modal, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid rgb(58 70 228)',
    borderRadius: '5px',
    boxShadow: 24,
    p: 4,
};

export default function Validating(props: any) {
    const { isLoading } = useSelector((state: RootState) => state.shared);

    return (
        <div>
            <Modal open={isLoading} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {props.message}
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%', mr: 1 }}>
                        <LinearProgress style={{ flex: 1 }} />
                    </Stack>
                </Box>
            </Modal>
        </div>
    );
}
